import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectShowRecipientWellOption')(function selectShowRecipientWellOption(field, isChecked, state) {
    var optionState = state.optionState;
    optionState[field] = isChecked;
}));
//# sourceMappingURL=selectShowRecipientWellOption.js.map